import { create } from 'zustand'

const KANBAN_CITY_FILTER_KEY = 'stryzh_admin.kanban.city_filter'
const LEADS_CITY_FILTER_KEY = 'stryzh_admin.inspection_leads.city_filter'

function loadCityFilter(key: string): string[] {
  try {
    const raw = window.localStorage.getItem(key)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    if (Array.isArray(parsed)) {
      return parsed.filter((x): x is string => typeof x === 'string')
    }
  } catch {
    // private mode / квота — молча (как в utils/order-detail-ui.ts)
  }
  return []
}

function saveCityFilter(key: string, cities: string[]): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(cities))
  } catch {
    // см. loadCityFilter
  }
}

interface UiState {
  sidebarCollapsed: boolean
  showArchiveKanban: boolean
  /** Выбранные города-фильтры канбана заказов. Пусто = показывать все. */
  kanbanCityFilter: string[]
  /** Выбранные города-фильтры канбана лидов («Осмотры Avito»). Пусто = все. */
  leadsCityFilter: string[]
  setSidebarCollapsed: (v: boolean) => void
  setShowArchiveKanban: (v: boolean) => void
  setKanbanCityFilter: (v: string[]) => void
  setLeadsCityFilter: (v: string[]) => void
}

export const useUiStore = create<UiState>((set) => ({
  sidebarCollapsed: false,
  showArchiveKanban: false,
  kanbanCityFilter: loadCityFilter(KANBAN_CITY_FILTER_KEY),
  leadsCityFilter: loadCityFilter(LEADS_CITY_FILTER_KEY),
  setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
  setShowArchiveKanban: (showArchiveKanban) => set({ showArchiveKanban }),
  setKanbanCityFilter: (kanbanCityFilter) => {
    saveCityFilter(KANBAN_CITY_FILTER_KEY, kanbanCityFilter)
    set({ kanbanCityFilter })
  },
  setLeadsCityFilter: (leadsCityFilter) => {
    saveCityFilter(LEADS_CITY_FILTER_KEY, leadsCityFilter)
    set({ leadsCityFilter })
  },
}))
